<template>
	<v-tooltip top>
		<v-btn
			flat
			icon
			slot="activator"
			small
			:color="color"
			@click.prevent="clickIcon"
			:disabled="disabled"
		>
			<v-icon v-bind:style="isListAll">{{ icon }}</v-icon>
		</v-btn>
		<span>{{ text }}</span>
	</v-tooltip>
</template>

<script>

function clickIcon() {
	this.$emit('click-icon');
}

function isListAll() {
	return this.icon === 'list_all' ? 'height:24px;width:24px' : '';
}

export default {
	name: 'app-tooltip-button',
	computed: {
		isListAll,
	},
	props: {
		disabled: {
			type: Boolean,
			default: false,
		},
		color: {
			type: String,
			default: 'green',
		},
		icon: {
			type: String,
			required: true,
		},
		text: {
			type: String,
			required: true,
		},
	},
	methods: {
		clickIcon,
	},
};
</script>



// WEBPACK FOOTER //
// src/components/shared/app-tooltip-button.vue